export function formatMinutes(totalMinutes: number): string {
    const heures = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    const heuresPart = heures > 0 ? `${heures} heure${heures > 1 ? 's' : ''}` : '';
    const minutesPart = minutes > 0 ? `${minutes} minute${minutes > 1 ? 's' : ''}` : '';

    if (heuresPart && minutesPart) {
        return `${heuresPart} ${minutesPart}`;
    } else if (heuresPart) {
        return heuresPart;
    } else if (minutesPart) {
        return minutesPart;
    } else {
        return '0 minute';
    }
}

export const formatPeriod = (startDate: Date, endDate: Date, intervalMs: number): string => {
    const currentYear = new Date().getFullYear();
    const startYear = startDate.getFullYear();
    const endYear = endDate.getFullYear();
    const sameYear = startYear === endYear && startYear === currentYear;

    const formatDate = (date: Date, showYear: boolean) => {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return showYear ? `${day}/${month}/${year}` : `${day}/${month}`;
    };

    const INTERVAL_24H = 86400000;
    const INTERVAL_48H = 172800000;

    if (intervalMs === INTERVAL_24H) {
        return formatDate(startDate, !sameYear);
    } else if (intervalMs >= INTERVAL_48H) {
        const showYear = startYear !== currentYear || endYear !== currentYear || startYear !== endYear;
        return `${formatDate(startDate, showYear)} - ${formatDate(endDate, showYear)}`;
    } else {
        return `${startDate.toLocaleDateString('fr-FR')} ${startDate.getHours()}h-${endDate.getHours()}h`;
    }
};

export const roundToNiceInterval = (value: number): number => {
    if (value === 0) return 0;
    
    const intervals = [
        30000,
        60000,
        300000,
        600000,
        1800000,
        3600000,
        10800000,
        21600000,
        43200000,
        86400000
    ];
    
    for (const interval of intervals) {
        if (value <= interval) {
            return interval;
        }
    }
    
    return Math.ceil(value / 86400000) * 86400000;
};

export const formatResponseTime = (milliseconds: number): string => {
    const seconds = Math.floor(milliseconds / 1000);
    if (seconds < 1) return '0 seconde';
    
    const days = Math.floor(seconds / 86400);
    const hours = Math.floor((seconds % 86400) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    const parts: string[] = [];
    if (days > 0) parts.push(`${days}j`);
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0) parts.push(`${minutes}m`);
    if (secs > 0) parts.push(`${secs}s`);

    if (parts.length === 0) return '0 seconde';
    if (parts.length === 1) {
        const part = parts[0]!;
        if (part.endsWith('s')) {
            const value = parseInt(part);
            return value > 1 ? part.slice(0, -1) + ' secondes' : part.slice(0, -1) + ' seconde';
        }
        return part;
    }

    return parts.join(' ');
};

export const formatDiscordTimestamp = (date: number, displayTodayText: boolean = false): string => {
    const d = new Date(date);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');

    const isToday = d.getDate() === today.getDate() && d.getMonth() === today.getMonth() && d.getFullYear() === today.getFullYear();

    const isYesterday = d.getDate() === yesterday.getDate() && d.getMonth() === yesterday.getMonth() && d.getFullYear() === yesterday.getFullYear();

    if (isToday) {
        return displayTodayText ? `Aujourd'hui à ${hours}:${minutes}` : `${hours}:${minutes}`;
    }

    if (isYesterday) {
        return `Hier à ${hours}:${minutes}`;
    }

    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}-${month}-${year} ${hours}:${minutes}`;
};